import React, { useCallback, useEffect, useState } from 'react';
import '../../assets/css/componentStyles/ScrollToTop.css';

export default function ScrollToTop({ showAfter = 200, className = '' }) {
  const [visible, setVisible] = useState(false);

  const updateVisibility = useCallback(() => {
    setVisible(window.pageYOffset > showAfter);
  }, [showAfter]);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateVisibility();
          ticking = false;
        });
        ticking = true;
      }
    };

    updateVisibility();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [updateVisibility]);

  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const scrollToTop = (e) => {
    e?.preventDefault?.();
    if (prefersReducedMotion) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      scrollToTop(e);
    }
  };

  return (
    <button
      type="button"
      className={`stt ${visible ? 'stt--visible' : ''} ${className}`}
      onClick={scrollToTop}
      onKeyDown={onKeyDown}
      aria-label="Scroll to top"
      title="Scroll to top"
    >
      {/* Chevron icon */}
      <svg
        width="24"
        height="12"
        viewBox="0 0 24 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="stt__icon"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.722669 10.0718L0.00195312 10.7153L1.44341 12.0022L2.16413 11.3587L12.0026 2.57463L21.841 11.3587L22.5617 12.0022L24.0032 10.7153L23.2825 10.0718L13.444 1.28767L13.4446 1.28717L12.0031 0.000244141L12.0026 0.000717559L12.002 0.000244141L10.5606 1.28717L10.5611 1.28767L0.722669 10.0718Z"
          fill="#252153"
        />
      </svg>

      <span className="stt__label">TOP</span>
    </button>
  );
}
